import React, { PureComponent } from 'react';
import { object, string } from 'prop-types';
import {
  LOGIN_ACTION_LOGIN,
  LOGIN_ACTION_OTP_FORM,
  LOGIN_ACTION_SIGN_UP,
  LOGIN_ACTION_SIGN_UP_VERIFY,
} from '../../constants';
import SignUpForm from '../SignUpForm/connected';
import VerifyPhone from '../SignUpForm/PhoneNumberVerify';
import LoginForm from '../LoginForm/ConnectedLoginForm';
import { SIGN_UP_LOGIN_CONTROLLER, SIGN_UP_SWITCH_ACTION } from '../../core/analytics/events';
import { analyticsTrackEvent } from '../../core/analytics';

export default class LoginController extends PureComponent {
  static propTypes = {
    login: object.isRequired,
    defaultAction: string,
  };

  componentDidMount() {
    const {
      login: { action },
      defaultAction,
    } = this.props;
    const loginAction = action || defaultAction;
    analyticsTrackEvent(SIGN_UP_LOGIN_CONTROLLER, {
      loginAction,
    });
  }

  componentDidUpdate(prevProps) {
    const {
      login: { action },
      defaultAction,
    } = this.props;
    const {
      login: { action: oldAction },
    } = prevProps;
    const loginAction = action || defaultAction;

    if (loginAction !== oldAction) {
      analyticsTrackEvent(SIGN_UP_SWITCH_ACTION, {
        loginAction,
      });
    }
  }

  get form() {
    const {
      login: { action },
      defaultAction,
    } = this.props;
    const loginAction = action || defaultAction;

    switch (loginAction) {
      case LOGIN_ACTION_SIGN_UP:
        return SignUpForm;
      case LOGIN_ACTION_SIGN_UP_VERIFY:
        return VerifyPhone;
      default:
      case LOGIN_ACTION_LOGIN:
      case LOGIN_ACTION_OTP_FORM:
        return LoginForm;
    }
  }

  render() {
    const Form = this.form;
    return <Form {...this.props} />;
  }
}
